export const environment = {
  production: false,
  API_URL: 'https://billingmiddlewareapi-develop.azurewebsites.net',
  name: 'Desarrollo',
};
